var React = require('react');

function IconUsergroup (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M842.2 385.6c0-45.5-36.5-82.3-82-82.3s-82.3 36.8-82.3 82.3 36.8 82.3 82.3 82.3 82-36.7 82-82.3zm-501.2 0c0-45.5-36.5-82.3-82-82.3s-82.3 36.8-82.3 82.3 36.8 82.3 82.3 82.3 82-36.7 82-82.3zm300.2-65.1c0-71.8-57.5-129.8-129.4-129.8S382 248.7 382 320.5s58 129.8 129.8 129.8 129.4-58 129.4-129.8zM266.7 636v194.8h488.8V636c0-81.3-163-122.2-244.4-122.2S266.7 554.6 266.7 636zm480.6-109.7c30.9 22.3 52.4 52.4 52.4 91.8v83.5h159.6v-83.5c0-62-124.2-93.1-186.2-93.1-7.7 0-16.5.5-25.8 1.3zm-472-1.7c-30.9 22.3-52.4 52.4-52.4 91.8v86.5H63.3v-86.5c0-62 124.2-93.1 186.2-93.1 7.8-.1 16.5.5 25.8 1.3z"}));
}

IconUsergroup.displayName = "IconUsergroup";

IconUsergroup.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconUsergroup;

IconUsergroup.default = IconUsergroup;
